(ns ballot-scout-v2-frontend.email.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::verify-email-success
 (fn [db]
   (get-in db [:verify-email :success])))

(rf/reg-sub
 ::verify-email-failure
 (fn [db]
   (get-in db [:verify-email :failure])))

(rf/reg-sub
 ::unsubscribe-email-success
 (fn [db]
   (get-in db [:unsubscribe-email :success])))

(rf/reg-sub
 ::unsubscribe-email-failure
 (fn [db]
   (get-in db [:unsubscribe-email :failure])))
